/**
 * Elegir una línea libre del padrón.  (spec 052 · FR-002)
 *
 * Rellena E.164 + ids. El token sale de la sesión Meta si hay; si no, se pega.
 */
import { useQuery } from '@tanstack/react-query'

import { api } from '../../lib/api'
import { lineasLibres, type LineaPadron, type PadronWhatsapp } from '../../lib/whatsapp'

export function SelectorLineaLibre({
    onElegir,
}: {
    onElegir: (l: {
        phoneNumber: string
        phoneNumberId: string
        businessAccountId: string
        apiKey?: string
    }) => void
}) {
    const padron = useQuery({
        queryKey: ['whatsapp', 'padron'],
        queryFn: () => api.get<PadronWhatsapp>('/whatsapp/padron'),
    })
    const token = useQuery({
        queryKey: ['whatsapp', 'token-sesion'],
        queryFn: () => api.get<{ apiKey: string | null }>('/whatsapp/token-sesion'),
        enabled: padron.data?.sesionMeta === true,
    })

    const libres = lineasLibres(padron.data)
    if (padron.isError || libres.length === 0) return null

    function elegir(e164: string) {
        const l: LineaPadron | undefined = libres.find((x) => x.e164 === e164)
        if (!l) return
        onElegir({
            phoneNumber: l.e164,
            phoneNumberId: l.phoneNumberId ?? '',
            businessAccountId: l.businessAccountId ?? '',
            ...(token.data?.apiKey ? { apiKey: token.data.apiKey } : {}),
        })
    }

    return (
        <label className="block text-xs text-neutral-400 md:col-span-2">
            Línea libre del padrón
            <select
                aria-label="Línea libre del padrón"
                data-testid="selector-linea-whatsapp"
                className="mt-1 w-full rounded border border-neutral-700 bg-neutral-950 px-2 py-1 text-sm text-neutral-100"
                defaultValue=""
                onChange={(e) => {
                    if (e.target.value) elegir(e.target.value)
                }}
            >
                <option value="">Elegir una línea…</option>
                {libres.map((l) => (
                    <option key={l.e164} value={l.e164}>
                        {l.e164}
                        {l.phoneNumberId ? ` · ${l.phoneNumberId}` : ''}
                    </option>
                ))}
            </select>
            <span className="mt-1 block text-neutral-500">
                Rellena el número y los ids. El token de Meta se usa si hay sesión; si no, se pega
                abajo.
            </span>
        </label>
    )
}
